import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import CustomerProfile from "./CustomerProfile";
import Tickets from "./Tickets";
import HeartBeat from "../HeartBeat";
import GetRepertory from "../../../GetRepertory";
import CustomerDashboard from "../../Blog/CustomerDashboard";
import CustomerBlogList from "../../Blog/CustomerBlogList";
import CustomerAddBlog from "../../Blog/CustomerAddBlog";
import BlogSection from "../../Blog/BlogSection";
import Research from "../../Blog/Research";
import CustomerRoleBlogs from "../../Blog/CustomerRoleBlogs";
import CustomerRoleResearch from "../../Blog/CustomerRoleResearch";
import PackagesPage from "../PackagesPage";
import PackageDetails from "./PackageDetails";
import CustomerResearchDetails from "../../Blog/CustomerResearchDetails";
import RepertoryDashboard from "../../../RepertoryDashboard";

const Customer = () => {
  const [customerData, setCustomerData] = useState({
    id: "",
    fullName: "",
    email: "",
    mobileNumber: "",
    dob: "",
    customerType: "",
    currentCountry: "",
    currentState: "",
    currentCity: "",
    currentAddressLine: "",
    permanentCountry: "",
    permanentState: "",
    permanentCity: "",
    permanentAddressLine: "",
    alternatePhoneNumber: "",
    currentYear: "",
    universityName: "",
    qualification: "",
    registrationNumber: "",
    stateRegistred: "",
    university: "",
    collage: "",
    currentJob: "",
    registrationCouncil: "",
    countryRegistredWith: "",
    institutionAttendedForHomeopathy: "",
  });
  return (
    <div>
      <HeartBeat />
      <Routes>
        <Route
          path="/profile"
          element={
            <CustomerProfile
              customerData={customerData}
              setCustomerData={setCustomerData}
            />
          }
        />
        <Route
          path="/tickets"
          element={
            <Tickets
              customerData={customerData}
              setCustomerData={setCustomerData}
            />
          }
        />
        <Route path="/dashboard" element={<CustomerDashboard/>}/>
        <Route path="/getrepertory" element={<GetRepertory/>}/>
        <Route path="/repertorydashboard" element={<RepertoryDashboard/>}/>
        <Route path="/blogs" element={<BlogSection/>}/>
        <Route path="/blogs/add" element={<CustomerAddBlog/>}/>
        <Route path="/dashboard/blog/list" element={<CustomerBlogList/>}/>
        <Route path="/dashboard/blog/research" element={<Research/>}/>
        <Route path="/customersroleblogs" element={<CustomerRoleBlogs/>}/>
        <Route path="/customerroleresearch" element={<CustomerRoleResearch/>}/>
        <Route path="research/:id" element={<CustomerResearchDetails />} />
        <Route path="/packages" element={<PackagesPage />} />
        <Route path="/package-details" element={<PackageDetails/>}/>
      </Routes>
    </div>
  );
};

export default Customer;
